import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
  Col, Row, Label, FormText,
} from 'reactstrap';
import { SchoolPrices } from '../../helpers/propTypes';

class View extends PureComponent {
  paymentDate() {
    const { isFreeTrial, paymentStartDate } = this.props;
    if (!isFreeTrial) {
      return paymentStartDate;
    }
    return new Date(paymentStartDate.getFullYear(), paymentStartDate.getMonth() + 1, 1);
  }

  freeTrialMonth() {
    return new Date(this.paymentDate().getFullYear(), this.paymentDate().getMonth() - 1, 1).getMonth() + 1;
  }

  paymentDateToString() {
    return `${this.paymentDate().getFullYear()}年${this.paymentDate().getMonth() + 1}月`;
  }

  render() {
    const { prices, isFreeTrial, showEntryFee } = this.props;
    const splitByThousands = (value) => value.toString().replace(/(\d)(?=(\d{3})+$)/g, '$1,');
    const renderPricesRow = (obj, attr, attr_name) => {
      if (obj[attr] === undefined) {
        return null;
      }
      return (
        <Row>
          <Col sm={7}>{attr_name}</Col>
          <Col className={`text-right ${obj[attr] < 0 ? 'discount' : ''}`}>
            {splitByThousands(obj[attr])}
            円
          </Col>
        </Row>
      );
    };
    return (
      <>
        <h2>お支払い情報</h2>
        {showEntryFee && (
          <>
            <Label className="font-weight-bold">入塾金</Label>
            {(() => {
              if (prices.entryOriginal === 0) {
                return <FormText color="danger" style={{ marginTop: 0, marginBottom: '10px' }}>対象キャンプに来られている、または来る予定の方、再入塾の方は入塾金免除となります。</FormText>;
              }
              if (isFreeTrial) {
                return <FormText style={{ marginTop: 0, marginBottom: '10px' }}>無料体験後にスクールに本参加される場合、入塾金は発生しません。</FormText>;
              }
            })()}
            <div className="price" style={{ marginBottom: '35px' }}>
              <div className="mx-auto" style={{ maxWidth: '235px' }}>
                {$.isEmptyObject(prices) || (prices.entryPrice === 0 && prices.coupon_discount < 0) ? (
                  <Row>
                    <Col className="total">税込</Col>
                    <Col className="total-price text-right">
                      <span>{$.isEmptyObject(prices) ? '-' : 0}</span>
                      円
                    </Col>
                  </Row>
                ) : (
                  <>
                    {renderPricesRow(prices, 'entryOriginal', '税別')}
                    {prices.couponDiscount < 0 && renderPricesRow(prices, 'couponDiscount', 'クーポン割引')}
                    {renderPricesRow(prices, 'entryTax', '消費税')}
                    <hr />
                    <Row style={{ marginTop: '12px' }}>
                      <Col className="total" style={{ paddingTop: '7px' }}>税込</Col>
                      <Col className="total-price text-right">
                        <span>{ splitByThousands(prices.entryPrice)}</span>
                        円
                      </Col>
                    </Row>
                  </>
                )}
              </div>
            </div>
          </>
        )}

        <Label className="font-weight-bold">受講料（毎月決済）</Label>
        {isFreeTrial ? (
          <p style={{ marginTop: '5px', marginBottom: '10px', fontSize: '16px' }}>
            <strike>
              月額
              {!$.isEmptyObject(prices) && prices.monthlyPrice !== 0 ? splitByThousands(prices.monthlyPrice) : ' - '}
              円（税込）
            </strike>
            <span className="ml-3">初月無料</span>
          </p>
        ) : (
          <p style={{ marginTop: '5px', marginBottom: '10px', fontSize: '14px' }}>
            月額
            <span style={{ fontSize: '20px', marginLeft: '10px', marginRight: '10px' }}>
              {!$.isEmptyObject(prices) && prices.monthlyPrice !== 0 ? splitByThousands(prices.monthlyPrice) : ' - '}
            </span>
            円（税込）
          </p>
        )}
        {!$.isEmptyObject(prices) && prices.innovationStudioSelected
          && (
          <FormText color="danger" style={{ marginTop: 0, marginBottom: '10px' }}>
            上記の受講料にはイノベーションスタジオ受講料 11,000円(税込)が含まれております。
          </FormText>
          )}
        {isFreeTrial ? (
          <FormText style={{ marginTop: 0, marginBottom: '10px' }}>
            無料体験期間中（
            {this.freeTrialMonth()}
            月分）の受講料は発生しません。
            <br />
            スクールに本参加後、ご登録のクレジットカードに受講料をご請求いたします。（決済日：毎月5日）
            <br />
            初回決済日は
            {this.paymentDateToString()}
            5日となります。
            <br />
            ※スクール無料体験で参加を終了される方は
            {this.freeTrialMonth()}
            月末日までにご申請が必要です。
          </FormText>
        ) : (
          <FormText color="danger" style={{ marginTop: 0, marginBottom: '10px' }}>
            ※受講料は毎月5日の決済となります。初回の決済日は
            {this.paymentDateToString()}
            5日です。
          </FormText>
        )}
      </>
    );
  }
}

View.defaultProps = {
  showEntryFee: true,
};

View.propTypes = {
  prices: SchoolPrices.isRequired,
  isFreeTrial: PropTypes.bool.isRequired,
  paymentStartDate: PropTypes.instanceOf(Date).isRequired,
  showEntryFee: PropTypes.bool,
};

export default View;
